export default "__VITE_ASSET__25885ba6__"